export class RelCiclosAtividadesFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getGrade(params) {
    return this.instance.get('/v1/relatorios/ciclos-atividades', { params });
  }

  getHistorico(linhaId, params) {
    return this.instance.get(
      `/v1/relatorios/ciclos-atividades/linhas/${linhaId}/historico`,
      { params },
    );
  }
}

export default RelCiclosAtividadesFactory;
